<template>
  <icon :name="name" :class="{
    'notificationsIcon': true,
    'notificationsIcon__info-blue' : isInfo,
    'notificationsIcon__success-green' : isSuccess,
    'notificationsIcon__warning-yellow' : isWarning,
    'notificationsIcon__error-red' : isError
    }" scale="1" ></icon>
</template>

<script>
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/times-circle'
import Icon from 'vue-awesome/components/Icon'
import {alertLevels} from './mixins'

export default {
  components: {
    Icon
  },
  mixins: [alertLevels],
  props: {
    notification: Object
  },
  computed: {
    name () {
      // Note that the vue awesome icon must be imported to have it here...
      if (this.isInfo) {
        return 'info-circle'
      } else if (this.isSuccess) {
        return 'check-circle'
      } else if (this.isWarning) {
        return 'exclamation-triangle'
      } else if (this.isError) {
        return 'times-circle'
      } else {
        return 'info-circle'
      }
    }
  }
}
</script>

<style lang="scss">
.notificationsIcon {
  cursor: pointer;
  
  &__info-blue {
    color: #4CBEE7;
  }
  &__success-green {
    color: rgb(75, 207, 42);
  }
  &__warning-yellow {
    color: rgb(235, 214, 31);
  }
  &__error-red {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// NotificationIcon.vue?0b4144f4